module.exports = __webpack_public_path__ + "static/media/icon-formlabel.dea6dba5.png";